import { USER_DATA_CONSTANT } from "../../_constants/Redux/userData.constant";
let initialObj = {
  employee: [],
  site: [],
  areaOfOperationData: [],
  department: [],
  myIncidents: [],
  incidents: {},
  contractorPerson: {},
  contractor: [],
  medicalAll: [],
  viewVfl: [],
  myVfl: [],
  capa: [],
  allEventSchedule: [],
  fromA: [],
  basicTraining: [],
  newBasicTraining: [],
  trainingBatchDetails: [],
  availableSites: {},
  trainingAllData: [],
  medicalAllData: [],
  contPersonForOthrModuel: [],
  employeeForOthrModuel: [],
  contractorForOthrModuel: [],
  medicalInActiveUnassigned: {},
  medicalInActiveAssigned: {},
  trainingInActiveUnassigned: {},
  trainingInActiveAssigned: {},
  oldEmployee: [],
  oldContractorPerson: [],
  employeeInActiveUnassigned: [],
  employeeInActiveAssigned: [],
  conPersonInActiveUnassigned: {},
  conPersonInActiveAssigned: {},
};

const UserManagementReducer = (state = initialObj, action) => {
  switch (action.type) {
    case USER_DATA_CONSTANT.SET_EMPLOYEE_DATA:
      if (action?.data?.data?.employees) {
        return { ...state, employee: [...action?.data?.data?.employees] };
      }
      break;

    case USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_UNASSIGNED:
      if (action?.data?.data?.employees) {
        return {
          ...state,
          employeeInActiveUnassigned: [...action?.data?.data?.employees],
        };
      }
      break;
    case USER_DATA_CONSTANT.EMPLOYEE_IN_ACTIVE_ASSIGNED:
      if (action?.data?.data?.employees) {
        return { ...state, employeeInActiveAssigned: [...action?.data?.data?.employees] };
      }
      break;

    case USER_DATA_CONSTANT.SITE:
      if (action?.data?.data?.data) {
        return { ...state, site: [...action?.data?.data?.data] };
      }
      break;

    case USER_DATA_CONSTANT.AREA_OF_OPERATION:
      if (action?.data?.data?.data) {
        return { ...state, areaOfOperationData: [...action?.data?.data?.data] };
      }
      break;

    case USER_DATA_CONSTANT.DEPARTMENT:
      if (action?.data?.data?.data?.departments) {
        return { ...state, department: [...action?.data?.data?.data?.departments] };
      }
      break;

    case USER_DATA_CONSTANT.MY_INCIDENTS:
      if (action?.data?.data?.data) {
        return { ...state, myIncidents: [...action?.data?.data?.data] };
      }
      break;

    case USER_DATA_CONSTANT.INCIDENTS:
      if (action?.data?.data?.data) {
        return { ...state, incidents: { ...action?.data?.data?.data } };
      }
      break;

    case USER_DATA_CONSTANT.CONTRACTOR:
      if (action?.data?.data?.data) {
        return { ...state, contractor: { ...action?.data?.data?.data } };
      }
      break;

    case USER_DATA_CONSTANT.CONTRACTOR_PERSON:
      return { ...state, contractorPerson: { ...action } };
    case USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_UNASSIGNED:
      return { ...state, conPersonInActiveUnassigned: { ...action } };
    case USER_DATA_CONSTANT.CONTRACTOR_PERSON_IN_ACTIVE_ASSIGNED:
      return { ...state, conPersonInActiveAssigned: { ...action } };

    case USER_DATA_CONSTANT.MEDICAL_ALL:
      return { ...state, medicalAll: { ...action } };

    case USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_UNASSIGNED:
      return { ...state, medicalInActiveUnassigned: { ...action } };
    case USER_DATA_CONSTANT.MEDICAL_IN_ACTIVE_ASSIGNED:
      return { ...state, medicalInActiveAssigned: { ...action } };

    case USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_UNASSIGNED:
      return { ...state, trainingInActiveUnassigned: { ...action } };
    case USER_DATA_CONSTANT.TRAINING_IN_ACTIVE_ASSIGNED:
      return { ...state, trainingInActiveAssigned: { ...action } };

    case USER_DATA_CONSTANT.MEDICAL_ALL_DONE:
      return { ...state, medicalAllData: { ...action } };

    case USER_DATA_CONSTANT.ALL_TRAINING_DATA:
      return { ...state, trainingAllData: { ...action } };

    case USER_DATA_CONSTANT.VIEW_VFL:
      return { ...state, viewVfl: { ...action } };

    case USER_DATA_CONSTANT.MY_VFL:
      return { ...state, myVfl: { ...action } };

    case USER_DATA_CONSTANT.CAPA:
      return { ...state, capa: { ...action } };

    case USER_DATA_CONSTANT.ALL_EVENT_SCHEDULE:
      return { ...state, allEventSchedule: { ...action } };

    case USER_DATA_CONSTANT.FORM_A:
      return { ...state, formA: { ...action } };

    case USER_DATA_CONSTANT.BASIC_TRAINING:
      return { ...state, basicTraining: { ...action } };

    case USER_DATA_CONSTANT.NEW_BASIC_TRAINING:
      return { ...state, newBasicTraining: { ...action } };

    case USER_DATA_CONSTANT.TRAINING_BATCH_DETAILS:
      return { ...state, trainingBatchDetails: { ...action } };

    case USER_DATA_CONSTANT.AVAILABLE_SITES:
      return { ...state, availableSites: { ...action } };

    case USER_DATA_CONSTANT.CONTRACTOR_PERSON_FOR_OTHER_MODUEL:
      return { ...state, contPersonForOthrModuel: [...action?.data] };
    case USER_DATA_CONSTANT.EMPLOYEE_FOR_OTHER_MODUEL:
      return { ...state, employeeForOthrModuel: [...action?.data] };
    case USER_DATA_CONSTANT.OLD_CONTRACTOR_PERSON:
      return { ...state, oldContractorPerson: [...action?.data] };
    case USER_DATA_CONSTANT.OLD_EMPLOYEE:
      return { ...state, oldEmployee: [...action?.data] };
    case USER_DATA_CONSTANT.CONTRACTOR_FOR_OTHER_MODUEL:
      return { ...state, contractorForOthrModuel: [...action?.data] };

    default:
      return state;
  }
};

export default UserManagementReducer;
